import React from 'react';
import Footer from '../components/Footer';
import './DriversPage.css';
import DriverImg from '../assets/driver.png'

import BosZaman from '../assets/ikon1.svg';
import Tesvik from '../assets/ikon2.svg';
import Yakit from '../assets/ikon3.svg';
import Bolge from '../assets/ikon4.svg';
import Calisma from '../assets/ikon5.svg';
import Colors from '../Colors';
import NavBar from '../components/NavBar';
export default class DriversPage extends React.Component {

    constructor() {
        super();

        this.state ={expanded:0}
    }
    render() {

        return <div style={{paddingTop:0}}>
                <NavBar />

            <div style={{justifyContent:"center",  display:"flex",paddingTop:100,backgroundColor:"#F6F6F6"}}>
                <img src={DriverImg} style={{ width:"100%", marginTop:10, backgroundSize:"cover", backgroundRepeat:"no-repeat", backgroundPosition:"center",  alignItems:"center", display:"flex"}} />
                <div style={{display:"flex",flexDirection:"column", position:"absolute", alignItems:"center"}}>
                    <p className='deliverT' style={{color:"black", paddingTop:"1vw"}}>Şimdi Taşımacım Sürücüsü Olun</p>
                    <p className='deliverSubT mobileHide' style={{marginTop:"8.3vw", color:"black"}}>Boş Zamanınızda Para Kazanın</p>

                    <a href='apply' className='getQuoteButton mobileHide' style={{paddingTop:14,marginTop:20, paddingBottom:16, fontSize:16, border: "1.5px solid "+Colors.Blue, borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32, textDecoration:"none"}}>Şimdi Üye Ol</a>
                
                </div>
            </div>
            {/* <div style={{ width:"100%",backgroundSize:"cover", backgroundRepeat:"no-repeat", backgroundPosition:"center", minHeight:800, alignItems:"center", paddingLeft:100,display:"flex",backgroundImage: "url(../assets/driver.svg)"}}>

                <div style={{width: 400, display:"flex",flexDirection:"column"}}>
                    <p className='deliverT'>Şimdi bir Taşımacım Sürücüsü Olun</p>
                    <p className='deliverSubT'>Boş Zamanınızda Para Kazanın</p>

                    <a href='apply' className='getQuoteButton' style={{paddingTop:14,marginTop:20, paddingBottom:16, fontSize:16, border: "1.5px solid #4B9D2A", borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32, textDecoration:"none"}}>Şimdi Üye Ol</a>
                
                </div>

            </div> */}
            <div style={{width:"100%", display:"flex", justifyContent:"center"}}>
            <div style={{maxWidth: 1140, display:"flex", width:"100%", marginTop:72,flexWrap:"wrap"}}>
                
                <div style={{flex:1, alignItems:"center", display:"flex"}}>
                    <div style={{paddingLeft:50}}>
                    <p style={{fontSize:32}}>Neden Taşımacım?</p>

                    <p style={{fontWeight:"600", marginTop:20}}>Boş zamanlarınızda ekstra para kazanın</p>
                    <p>Size en yakın siparişlerle eşleştirin ve boş zamanlarınızda para kazanın.</p>

                    <p style={{fontWeight:"600", marginTop:20}}>Çalışma bölgenizi seçin</p>
                    <p>Sipariş teslim ve teslimat bölgelerini seçerek çalışma alanlarınızı siz belirleyin.</p>

                    <p style={{fontWeight:"600", marginTop:20}}>Değişken petrol fiyatlarından etkilenmeyin</p>
                    <p>Sipariş fiyatlamamız günlük güncellenen benzin fiyatlarıyla hesaplanır.</p>

                    <p style={{fontWeight:"600", marginTop:20,color:Colors.Blue}}>Masraflarınızdan 0% komisyon</p>
                    <p>Paralı yol ücretleri ve yakıt masraflarından Taşımacım'a komisyon ödemeyin.</p>

                    

                    <p style={{fontWeight:"600", marginTop:20}}>Taşımacım teşvik programları ile daha fazla kazanın</p>
                    <p>Aylık sipariş hedeflerine ulaşın ve ek teşvikler kazanın.</p>
                    </div>
                </div>
            </div>


            
            </div>

            <div style={{width:"100%", display:"flex", justifyContent:"center", backgroundColor:"#f3f7f8", marginTop:92,paddingBottom:72}}>
                <div style={{maxWidth:1140, display:"flex", width:"100%", marginTop:72, flexDirection:"column"}}>
                <p style={{textAlign:"center", fontSize:32,color: "#00121A"}}>Lojistik Ortaklarımızın Avantajları</p>
                <p style={{textAlign:"center", fontSize:16,color: "#00121A", marginTop:10}}>Sadece sürücülerimize iş fırsatı sunmuyoruz, kazanırken masraflarınızı da düşünüyoruz.</p>
                

                <div style={{display:"flex", marginTop:50,flexWrap:"wrap"}}>
                    <ServiceBubble title={"Çalışacağınız saatleri kendiniz belirleyin"} img={Calisma} />
                    <ServiceBubble title={"Masraflarınızdan komisyon ödemeyin"} img={BosZaman} />
                    <ServiceBubble title={"Değişen yakıt ücretlerinden etkilenmeyin"} img={Yakit} />
                    <ServiceBubble title={"Belirlediğiniz bölgelerde hizmet verin"} img={Bolge} />
                    
                    
                    <ServiceBubble title={"Çalıştıkca daha çok kazanın"} img={Tesvik} />
                </div>
                

                {/* <button className='additionalServicesButton' style={{paddingTop:16,alignSelf:"center",marginTop:50, paddingBottom:16, marginBottom:72,fontSize:16, border: "1.5px solid #4B9D2A", borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32}}>Additional Services</button> */}
                </div>
            </div>


            <div style={{width:"100%", display:"flex", justifyContent:"center", marginTop:75,marginBottom:75}}>
                <div style={{maxWidth:1140, display:"flex", width:"100%", flexDirection:"column", alignItems:"center"}}>
                    <p style={{fontSize:32}}>Nasıl üye olunur?</p>
                    <p style={{textAlign:"center", marginTop:10}}>Birkaç basit adımla başlayalım.</p>
                    <div className="elementor-widget-container" style={{marginTop:60}}>
			<div className="process-block"><div className="wrapper"><div className="line"></div><div className="item width4"><div className="counter">1</div><h4>Üye olun</h4><p></p><p>Sitemizden veya uygulamamız aracılığıyla kaydolun.</p><p></p></div><div className="item width4"><div className="counter">2</div><h4>Kişisel bilgileri girin</h4><p>Kişisel bilgilerinizi ve araç bilgilerinizi girin.</p></div><div className="item width4"><div className="counter">3</div><h4>Belgelerinizi Yükleyin</h4><p>Gerekli olan belgeler: Ehliyet, Nüfus cüzdanı fotokopisi, İkametgâh Belgesi ve Adli sicil kaydı</p></div><div className="item width4"><div className="counter">4</div><h4>Onaylanma Süreci</h4><p></p><p>Belgeleriniz incelenip onaylandıktan sonra Taşımacım'dan tarafından internet üzerinden eğitime katılmanız için bildirim alacaksınız.</p><p></p></div></div></div>		</div>
                    

            <a href='apply' className='getQuoteButton' style={{paddingTop:14,marginTop:60, paddingBottom:16, fontSize:16, border: "1.5px solid "+Colors.Blue, borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32, textDecoration:"none"}}>Şimdi Üye Ol</a>
                
                </div>


                
            </div>

            
        

            <Footer />
        </div>
    }
}

const Expandable = (props) => {
    return <div style={{backgroundColor:(props.expanded)?"#006E9B":"white",transition:"all .2s", paddingTop:25,paddingBottom:25,paddingLeft:40, width:"100%",border:(props.expanded)?"none":"1.5px solid #E3E7EC", borderRadius:4, marginBottom:20}}>
        <div style={{cursor:"pointer", display:"flex", flexDirection:"row", justifyContent:"space-between", paddingRight:40}}  onClick={() => props.onPress()}>
            <p style={{fontSize:20,lineHeight:"32px",color:(props.expanded)?"white":"#000"}}>{props.title}</p>
            <div className={(props.expanded)?'indicator active':'indicator'}></div>
            
            </div>
        <div className={(props.expanded)?'expanded expand':'expanded'} >
            <p style={{paddingRight:40,color:"white",fontSize:16,lineHeight:"24px"}}>{props.desc}</p>
        </div>
    </div>
}

const ServiceBubble = (props) => {
    return <div className='serviceBubble' style={{flex:1, display:"flex", flexDirection:"column", alignItems:"center"}}>
        <img style={{width:128,height:128}} src={props.img} />
        <p style={{flexWrap:"wrap", color:"#00121A", textAlign:"center", marginTop:10,fontSize:20,maxWidth:200}}>{props.title}</p>
    </div>
}

const VehiclePricing = (props) => {
    return <div className='routeDiv' style={{flex:1, display:"flex", height:370, border: "1.5px solid #E3E7EC",marginLeft:12, marginRight:12, justifyContent:"center", alignItems:"center"}}>
        <div style={{width:"100%", padding: 40,height:"100%", alignItems:"center", justifyContent:"flex-start", display:"flex",flexDirection:"column"}}>
            <div style={{width:72,height:72, backgroundColor: "#EBEBEB", borderRadius:"50%", display:"flex", justifyContent:"center", alignItems:"center"}}>
                <img style={{height:45,position:"absolute"}} src='https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/10091155/Group-105%402x.png' />
            </div>

            <p style={{marginTop:20,marginBottom:20,fontSize:20}}>Van</p>

            <p style={{textAlign:"center", color:"#4A4A4A",lineHeight:"1.5em"}}>Max. load 700kg<br/>Available storage space dimensions:<br/>5.5’ length, 4’ height, and 4’ width</p>
            <a href='pricing' style={{color:"#0088BF"}}>Route Fee</a>
            
        </div>
    </div>
}


